import { AfterViewInit, Component, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ClassReport } from '../data/class-report';

enum Page {
  Summary,
  Weekly,
  EEU
}

@Component({
  selector: 'app-class-report',
  templateUrl: './class-report.component.html',
  styleUrls: ['./class-report.component.scss']
})
export class ClassReportComponent extends BaseComponent implements AfterViewInit {
  Page = Page;

  @Input() classID: number;
  @Input() organizationId: number;
  showingPage: Page = Page.Summary;

  report: ClassReport;

  isInternal = this.authService.isInternal();

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      this.classID = params.classId;
      this.getClassReport();
    });
    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.st) {
        this.showingPage = (<any>Page)[queryParams.st];
      }
      else {
        this.showingPage = Page.Summary;
      }
    });
  }

  getClassReport(): void {
    this.dataService.getClassReport(this.classID)
      .subscribe(r => {
        this.report = r;
        this.report.Students.forEach(e => {
          if (!e.CurrentUnit) e.CurrentUnit = 0;
          if (!e.TimeInCourse) e.TimeInCourse = 0;
        });
      });
  }

  switchTab(page: Page) {
    this.showingPage = page;
  }
}
